<template>
  <TransactionDetail />
</template>
<script>
import appConfig from '@/app.config'

import TransactionDetail from '../../../components/skillup/wallet/TransactionDetail.vue'

export default {
  page: {
    title: 'جزییات تراکنش',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'userTransactionDetailBaseOnStatus',
  components: {
    TransactionDetail,
  },
}
</script>
